import { render, staticRenderFns } from "./Share_Option_Copy.vue?vue&type=template&id=f18582d2&"
import script from "./Share_Option_Copy.vue?vue&type=script&lang=js&"
export * from "./Share_Option_Copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports